export const UPDATE_IS_SHOW = 'UPDATE_IS_SHOW'
export const UPDATE_ALERT_MODAL = 'UPDATE_ALERT_MODAL'
export const ADD_MODAL = 'ADD_MODAL'
